import { motion } from "framer-motion";

const chapters = [
  { n: "01", t: "Philosophie", q: "Je ne photographie pas des plats, je photographie le geste, la vapeur, l'instant précis où la cuisine devient émotion.", d: "Chaque shooting commence en cuisine, aux côtés du chef. Comprendre la recette avant de la cadrer, goûter avant de déclencher." },
  { n: "02", t: "Atmosphère", q: "La lumière est un ingrédient. Je la dose comme un assaisonnement, jusqu'à ce que l'image donne faim.", d: "Lumière naturelle chaude, textures brutes, vaisselle artisanale. Une signature gourmande, jamais artificielle." },
  { n: "03", t: "Perfection", q: "Le détail n'est pas un luxe : une goutte d'huile, un grain de sel — c'est là que naît l'appétit.", d: "Stylisme culinaire soigné, retouche fine art, livraison calibrée pour le print comme pour les réseaux." },
];

export const Manifesto = () => (
  <section id="manifeste" className="py-24 lg:py-32 bg-[#0D0D0C]">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
      <div className="overline mb-4">Le Manifeste</div>
      <h2 className="font-serif-d text-4xl lg:text-6xl tracking-tight max-w-2xl mb-20">Trois principes, une obsession.</h2>

      <div className="space-y-16 lg:space-y-24">
        {chapters.map((c, i) => (
          <motion.div key={c.n}
            initial={{ opacity: 0, y: 60 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
            className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-10 items-start border-t border-[#F4F0EB]/10 pt-10">
            <div className="lg:col-span-3">
              <span className="font-serif-d text-7xl lg:text-8xl text-[#1C1B18]" style={{ WebkitTextStroke: "1px #C88D51" }}>{c.n}</span>
              <div className="font-mono-a uppercase tracking-[0.2em] text-xs text-[#C88D51] mt-2">{c.t}</div>
            </div>
            <div className="lg:col-span-6">
              <p className="font-cormorant text-3xl lg:text-4xl leading-snug text-[#F4F0EB] italic">“{c.q}”</p>
            </div>
            <div className="lg:col-span-3">
              <p className="font-sub text-[#A39E93] text-sm leading-relaxed">{c.d}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
